import controller from './controller';
import template from './template.pug';

import pages from './pages';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$urlRouterProvider.when('/main/api', '/main/api/overview');

	$stateProvider.state('main.api', {
		url: '/api',
		controllerAs: 'ctrl',
		controller: controller,
		template: template
	})
		.state('main.api.overview', {
			url: '/overview',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.overview
		})
		.state('main.api.documentation', {
			url: '/documentation',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.documentation
		})
		.state('main.api.auth', {
			url: '/auth',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.auth
		})
		.state('main.api.account', {
			url: '/account',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.account
		})
		.state('main.api.personalPanels', {
			url: '/personal',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.personalPanels
		})
		.state('main.api.personalItems', {
			url: '/items',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.personalItems
		})
		.state('main.api.personalAccessConnect', {
			url: '/connect',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.personalAccessConnect
		})
		.state('main.api.personalAccessConfig', {
			url: '/config',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.personalAccessConfig
		})
		.state('main.api.personalAccessStatus', {
			url: '/status',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.personalAccessStatus
		})
		.state('main.api.personalAccessInfo', {
			url: '/info',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.personalAccessInfo
		})
		.state('main.api.personalAccessActions', {
			url: '/actions',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.personalAccessActions
		})
		.state('main.api.installAccess', {
			url: '/install',
			controllerAs: 'ctrl',
			controller: controller,
			template: pages.templates.accessInstallTemplate
		});

}




/** WEBPACK FOOTER **
 ** ./src/main/apiTest/routes.js
 **/